import { CopyButton as MantineCopyButton } from "@mantine/core";

export const CopyButton = MantineCopyButton;
